var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 264.334,
    height: 48.604,
    viewBox: "0 0 264.334 48.604",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_47",
    "data-name": "Group 47",
    transform: "translate(-71.159 -244.438)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_119",
    "data-name": "Path 119",
    d: "M71.159,279.438H96.184c4.7,0,7.594.506,9.619,1.664,3.255,1.808,4.774,5.352,4.774,11.066,0,4.629-.8,7.016-2.821,8.679a9.267,9.267,0,0,1-4.7,2.025v.217c6.437.8,8.534,3.544,8.534,11.428,0,9.836-3.689,13.163-14.682,13.163H71.159Zm20.83,19.746c4.412-.073,4.773-.145,5.714-.724,1.3-.723,1.808-2.169,1.808-4.846,0-4.122-1.013-4.99-5.5-4.99H82.3v10.56Zm-.362,19.311c7.522,0,8.9-.868,8.9-5.5,0-3.327-.578-4.774-2.242-5.5-.94-.361-1.157-.361-5.425-.434H82.3v11.428Z",
    transform: "translate(0 -35)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_120",
    "data-name": "Path 120",
    d: "M148.761,316.614v.941a11.422,11.422,0,0,1-1.808,6.581c-2.025,2.749-5.714,3.906-12.8,3.906-7.45,0-11.283-.94-13.815-3.327s-3.4-6.22-3.4-14.393c0-7.378.868-10.922,3.255-13.308,2.531-2.459,6.292-3.472,12.8-3.472,12.295,0,15.767,3.472,15.767,15.984v2.966h-22.2a11.29,11.29,0,0,0-.073,1.374c0,5.786,1.447,7.3,6.726,7.3,4.919,0,6-.868,6.076-4.557Zm-9.33-9.692a8.45,8.45,0,0,1-.073-1.157c-.072-4.411-1.085-5.207-6.437-5.207-3.761,0-5.063.506-5.786,2.242-.362.868-.434,1.446-.506,4.122Z",
    transform: "translate(0 -35)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_121",
    "data-name": "Path 121",
    d: "M165.1,327.68h-9.62V279.438h9.62Z",
    transform: "translate(0 -35)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122",
    "data-name": "Path 122",
    d: "M215.948,327.68H201.989L199.1,314.155c-.941-4.34-1.23-5.786-2.459-12.078h-.29l-.506,3.037c-.217.941-.434,1.953-.578,2.966-.145.8-.652,3.327-1.23,6.075L191.14,327.68H176.964l-6.8-33.776h9.475l2.531,14.32c.724,3.834.8,4.268,1.664,9.692l.506,3.255h.145l.723-3.255.651-3.255c0-.144.8-3.472,1.447-6.437l3.327-14.32h11.644l3.255,14.32c.723,3.183,1.229,5.353,1.446,6.437l.651,3.255.724,3.255h.216l.507-3.255c.8-5.135.94-5.931,1.663-9.692l2.6-14.32h9.33Z",
    transform: "translate(0 -35)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123",
    "data-name": "Path 123",
    d: "M255.578,296.58c2.387,2.386,3.327,5.858,3.327,12.946,0,15.478-2.748,18.516-16.563,18.516-8.028,0-12.151-1.447-14.248-4.846-1.663-2.821-2.025-5.352-2.025-13.887,0-7.088.94-10.487,3.617-12.874,2.459-2.242,5.568-2.893,13.235-2.893C250.082,293.542,253.191,294.265,255.578,296.58Zm-19.745,13.814c0,8.9.868,10.343,6.582,10.343,5.858,0,6.726-1.447,6.726-10.849,0-7.6-1.013-9.041-6.581-9.041C236.846,300.847,235.833,302.221,235.833,310.394Z",
    transform: "translate(0 -35)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124",
    "data-name": "Path 124",
    d: "M294.125,296.58c2.387,2.386,3.327,5.858,3.327,12.946,0,15.478-2.748,18.516-16.563,18.516-8.028,0-12.151-1.447-14.248-4.846-1.663-2.821-2.025-5.352-2.025-13.887,0-7.088.94-10.487,3.616-12.874,2.459-2.242,5.569-2.893,13.236-2.893C288.628,293.542,291.738,294.265,294.125,296.58ZM274.38,310.394c0,8.9.868,10.343,6.582,10.343,5.858,0,6.726-1.447,6.726-10.849,0-7.6-1.013-9.041-6.582-9.041C275.393,300.847,274.38,302.221,274.38,310.394Z",
    transform: "translate(0 -35)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_125",
    "data-name": "Path 125",
    d: "M335.493,327.68h-9.33l.361-5.93h-.216c-1.737,4.7-4.268,6.292-10.126,6.292-4.557,0-7.884-1.013-9.909-3.038-2.532-2.531-3.11-5.352-3.11-14.827,0-7.666.578-10.487,2.82-13.163,1.954-2.315,5.136-3.472,9.982-3.472,5.5,0,8.173,1.519,9.764,5.424h.144V279.438h9.62Zm-22.711-17.141c0,8.607,1.013,10.2,6.365,10.2,2.459,0,4.2-.434,5.207-1.374,1.23-1.157,1.519-2.893,1.519-8.752,0-8.1-1.012-9.547-6.8-9.547C313.65,301.064,312.782,302.366,312.782,310.539Z",
    transform: "translate(0 -35)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.761a0379.svg";
export { ForwardRef as ReactComponent };